import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import { useBookingContext } from '@providers/booking'
import { i18WithDefault as t } from '@shared/locale'
import { Types } from 'service-api'
import { getResourcesInAGroup } from './helper'

export const PreferredGroomer = ({ resources }: { resources: Types.ResourceClientDto[] }) => {
  const theme = useTheme()
  const bookingCtx = useBookingContext()
  const showProviderAvailabilityDates = bookingCtx.state.data?.serviceType?.showProviderAvailabilityDates ?? false

  const resourcesInAGroup = getResourcesInAGroup(bookingCtx.state)
  const resourcesToShow = resourcesInAGroup.length
    ? resources.filter((r) => resourcesInAGroup.includes(r.id as string))
    : resources

  const onChangePreferredGroomer = (ev: SelectChangeEvent<string>) => {
    bookingCtx.dispatch({
      type: 'SET_PREFERRED_GROOMER',
      payload: { value: ev.target.value, groupOverride: resourcesInAGroup.length > 0 },
    })

    if (showProviderAvailabilityDates) {
      bookingCtx.dispatch({ type: 'CLEAR_REQUEST_DATES' })
    }
  }

  const selectedPreferredGroomer =
    bookingCtx.state?.cart?.overrideResourceGroupId || bookingCtx.state?.cart?.overridePrimaryResourceId

  return (
    <Box>
      <Stack
        direction="row"
        alignItems="center"
        spacing={3}
        sx={{ maxWidth: '640px', margin: '0 auto', width: '100%' }}
      >
        <Typography flexGrow={1} variant="h6">
          {t('grooming.preferredGroomer.title')}
        </Typography>
        <FormControl sx={{ m: 1, width: '25ch' }}>
          <InputLabel
            id="grooming-select-label"
            sx={{
              padding: '0 5px',
              backgroundColor: theme.palette.common.white,
            }}
          >
            {t('grooming.preferredGroomer.label')}
          </InputLabel>
          <Select
            labelId="grooming-select-label"
            id="grooming-select"
            value={selectedPreferredGroomer || '0'}
            onChange={onChangePreferredGroomer}
          >
            <MenuItem value={'0'}>{t('grooming.preferredGroomer.none')}</MenuItem>
            {resourcesToShow?.map((resource) => (
              <MenuItem key={resource.id} value={resource.id}>
                {resource.displayName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
    </Box>
  )
}
